import axios, { STRAPI_URL } from '@propertypal/shared/src/services/axios.strapi';
import { IPropertyPalPrivacyPolicy } from '@propertypal/shared/src/types/strapi';
import { StrapiResponse } from '@propertypal/shared/src/types/strapi/generic';
import platform from '@propertypal/shared/src/utils/platform';
import PolicyContent from '@propertypal/web-ui/src/policy-content/PolicyContent';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../components/layout/MetaTags';

interface PrivacyPageProps {
  data: IPropertyPalPrivacyPolicy | null;
}

const metaData = {
  title: `Privacy Policy - ${platform.title}`,
  description: `${platform.title} Privacy Policy`,
  url: `/privacy`,
};

export const getStaticProps: GetStaticProps<PrivacyPageProps> = async () => {
  const result = await axios<StrapiResponse<IPropertyPalPrivacyPolicy>>({
    method: 'GET',
    url: `${STRAPI_URL}/${platform.select('property-pal-privacy-policy', 'propertynews-privacy-policy')}`,
    params: { populate: 'deep' },
  });

  return {
    props: {
      data: result.data.data,
    },
  };
};

const PrivacyPage: React.FC<PrivacyPageProps> = ({ data }) => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>
      {data?.attributes && <PolicyContent {...data?.attributes} />}
    </>
  );
};

export default PrivacyPage;
